import { Link } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './style.css';

export interface ICompareToastContentProps {
  text: string;
  comparisonUrl?: string;
  onClick?: () => void;
}

export function CompareToastContent({ text, comparisonUrl, onClick }: ICompareToastContentProps) {
  return (
    <div className={style['container']}>
      <span>{text}</span>
      {comparisonUrl && (
        <span className={style['link']}>
          <Link
            href={comparisonUrl}
            onClick={onClick}
            color="current_color"
            fontSize="M"
            fontWeight="bold"
            inline
            target="blank"
          >
            Посмотреть
          </Link>
        </span>
      )}
    </div>
  );
}
